export default __webpack_public_path__ + "static/app-mobile-custom-vantaggi-svantaggi-6b16742811632037f9b7bf1e374641a5.jpg";